import type { NextPage, GetStaticProps } from 'next';

import PageService from 'services/PageService/PageService';
import { IGenericPage } from 'types/interfaces';
import GlobalLayout from 'blocks/Layouts/GlobalLayout';
import { navigationPaths, PAGE_INVALIDATION_INTERVAL } from 'data/constants';
import PartnerWithUs from 'blocks/partner-with-us';

interface IPartnerWithUs extends IGenericPage {}

const PartnerWithUsHome: NextPage<IPartnerWithUs> = ({ globalLayoutProps }) => {
  return (
    <GlobalLayout {...globalLayoutProps}>
      <PartnerWithUs />
    </GlobalLayout>
  );
};

export default PartnerWithUsHome;

export const getStaticProps: GetStaticProps = async () => {
  const genericPageProps = await PageService.getGenericPageProps({
    navPath: navigationPaths.PARTNER_WITH_US,
  });
  return {
    props: {
      ...genericPageProps,
    },
    revalidate: PAGE_INVALIDATION_INTERVAL,
  };
};
